export default class GalleryComponent {
	constructor() {

		const gallery_components = document.querySelectorAll('.gallery_component');

		if (!gallery_components) return;

		gallery_components.forEach((gallery_component) => {

			const galleryThumbs = gallery_component.querySelector('.gallery-thumbs');
			const galleryComponent = gallery_component.querySelector('.gallery-component');

			if (galleryThumbs && galleryComponent) {

				const swiperThumb = new Swiper(galleryThumbs, {
					slidesPerView: 0,

					breakpoints: {
						0: {
							slidesPerView: 3
						},
						1200: {
							slidesPerView: 9
						}
					}
				});

				const slider_button_next = gallery_component.querySelector('.slider-button-next');
				const slider_button_prev = gallery_component.querySelector('.slider-button-prev');

				const slider = new Swiper(galleryComponent, {
					speed: 600,

					navigation: {
						nextEl: slider_button_next ?? '.slider-button-next',
						prevEl: slider_button_prev ?? '.slider-button-prev',
					},

					thumbs: {
						swiper: swiperThumb,
					},
				});

				slider.on('slideChange', function () {
					swiperThumb.slideTo(this.realIndex)
				});

				let galeriesThumb = gallery_component.querySelectorAll('.gallery-component-thumbs');

				if (galeriesThumb) {

					galeriesThumb.forEach(el => {
						let thumbs = el.querySelectorAll('.item-thumb');

						if (thumbs.length <= 1) {
							el.style.display = "none";
						}
					});
				}
			}
		});
	}
}
new GalleryComponent();